type ProductOrigin = {
  path: string;
  scrollY: number;
  productListSnapshot?: unknown;
  restoreRequested: boolean;
};

let productOrigin: ProductOrigin | null = null;

export function rememberProductOrigin(
  path: string,
  scrollY: number,
  productListSnapshot?: unknown
): void {
  productOrigin = { path, scrollY, productListSnapshot, restoreRequested: false };
}

export function requestProductReturn(): void {
  if (productOrigin) productOrigin.restoreRequested = true;
}

export function hasProductOrigin(): boolean {
  return productOrigin !== null;
}

export function getProductListSnapshot<T>(path: string): T | null {
  if (
    !productOrigin?.restoreRequested ||
    productOrigin.path !== path ||
    productOrigin.productListSnapshot === undefined
  ) {
    return null;
  }

  return productOrigin.productListSnapshot as T;
}

export function clearProductOrigin(): void {
  productOrigin = null;
}

export function takeProductOriginScroll(path: string): number | null {
  if (!productOrigin?.restoreRequested || productOrigin.path !== path) return null;
  const scrollY = productOrigin.scrollY;
  productOrigin = null;
  return scrollY;
}
